import { IconAutoFixHigh } from '@repo/design-system-cf/components/icons'
import { Tooltip } from 'primitives/tooltip'

import { useLinkComponent, useTranslations } from '../../contexts/header-config-context'

function buildSearchUrl(query: string) {
  return `https://search.creativefabrica.com${query ? `?search=${encodeURIComponent(query)}` : ''}`
}

export function AiSearchSlot({ query }: { query: string }) {
  const Link = useLinkComponent()
  const t = useTranslations()

  return (
    <Tooltip
      side="top"
      open
      withPortal={false}
      value={t('top_nav.ai_search_tooltip')}
      className="min-h-[16px] rounded-[2px] px-1 py-0.5 text-[11px] opacity-0 transition-opacity group-focus-within:opacity-100"
    >
      <Link
        href={buildSearchUrl(query)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('top_nav.ai_search_tooltip')}
        className="text-cf-dreamy-cloud-900 group-focus-within:bg-cf-violet group-focus-within:text-cf-white group-focus-within:border-white/30 hover:text-cf-violet border-cf-dreamy-cloud-600 z-10 -ml-[1px] flex items-center border-r px-3 transition-colors"
      >
        <IconAutoFixHigh className="h-5 w-5" />
      </Link>
    </Tooltip>
  )
}
